import { Modal, Btn } from "@/components/Kit";
import { FileText, ListChecks } from "lucide-react";

export function PrintRemisionDialog({ open, onClose, remisionId }) {
  return (
    <Modal open={open} onClose={onClose} title="Imprimir remisión">
      <p className="font-mono-data text-sm text-[#5C5A55] mb-4">
        ¿Cómo deseas imprimir esta remisión?
      </p>
      <div className="grid gap-3">
        <a
          href={`/imprimir/remision/${remisionId}?modo=concostos`}
          target="_blank"
          rel="noreferrer"
          onClick={onClose}
          data-testid="print-remision-with-costs"
          className="flex items-start gap-3 border border-[#E3E8EE] p-4 text-left hover:border-[#465B7F] hover:bg-[#E9EEF3] transition-colors"
        >
          <FileText size={18} className="text-[#465B7F] mt-0.5" />
          <span>
            <span className="block font-mono-data text-sm text-[#16202B] font-semibold">Con costos</span>
            <span className="block font-mono-data text-xs text-[#5C5A55]">Incluye precios unitarios, importes y totales.</span>
          </span>
        </a>
        <a
          href={`/imprimir/remision/${remisionId}?modo=sincostos`}
          target="_blank"
          rel="noreferrer"
          onClick={onClose}
          data-testid="print-remision-without-costs"
          className="flex items-start gap-3 border border-[#E3E8EE] p-4 text-left hover:border-[#465B7F] hover:bg-[#E9EEF3] transition-colors"
        >
          <ListChecks size={18} className="text-[#465B7F] mt-0.5" />
          <span>
            <span className="block font-mono-data text-sm text-[#16202B] font-semibold">Solo cantidades</span>
            <span className="block font-mono-data text-xs text-[#5C5A55]">Muestra únicamente conceptos y cantidades a entregar.</span>
          </span>
        </a>
      </div>
      <div className="flex justify-end mt-5">
        <Btn variant="ghost" type="button" onClick={onClose}>Cancelar</Btn>
      </div>
    </Modal>
  );
}
